import { useRender } from "../../context/renderContext";
import { useIssuesData } from "../../hooks/useIssues";
import IssueDonutCard from "../ui/IssueDonutCard";
const colors = ["#64b5f6", "#ff8a65", "#aed581", "#ffd54f", "#4db6ac", "#ba68c8"];
const EmotionalVenting = () => {
  const { selectedOption, setSelectedOption, options } = useRender();
  const { issuesData } = useIssuesData();
  const handleChange = (event) => {
    setSelectedOption?.(event.target.value);
  };
  const prepareChartData = (ventingData) => Object.entries(ventingData ?? {}).map(([label, value], index) => ({
    id: index,
    value,
    color: colors[index % colors.length],
    label
  }));
  const chartData = issuesData ? prepareChartData(issuesData.ventingIssues) : [];
  return <IssueDonutCard
    title="Emotional Venting"
    count={issuesData?.ventingIssuesCount || 0}
    caption="Total users dealing with venting issues"
    chartData={chartData}
    chartTitle="Venting Issues"
    accent="teal"
    dropdown={{ value: selectedOption, onChange: handleChange, options }}
  />;
};
var EmotionalVenting_default = EmotionalVenting;
export {
  EmotionalVenting_default as default
};